// External modules
import React from 'react';

export const ShieldCheckSpot = (): React.ReactElement => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="lightblue"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="purchase-protection">
      <rect
        xmlns="http://www.w3.org/2000/svg"
        y="14"
        x="15"
        width="18"
        height="18"
        fill="#003087"
      />
      <path
        id="Color"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 44.0057C24.2409 44.0057 24.4786 43.9498 24.6943 43.8424C27.767 42.3134 40 35.2302 40 21.8121V11.3151C40 10.549 39.3131 9.91802 38.4314 9.86524C30.2205 9.36928 27.5032 6.81496 25.2182 4.50513C24.5445 3.82444 23.3244 3.83298 22.6623 4.52298C20.4425 6.83669 17.7174 9.47095 9.56782 9.96692C8.68612 10.0205 8 10.6507 8 11.4175V21.9107C8 35.2419 20.2329 42.315 23.3057 43.8424C23.5214 43.9498 23.7591 44.0057 24 44.0057ZM28.9395 18.2769L22.0639 27.2371L19.0784 24.171C18.5005 23.5775 17.5508 23.5649 16.9573 24.1428C16.3637 24.7207 16.3511 25.6704 16.929 26.2639L20.7208 30.158C21.5711 31.0314 22.9983 30.9474 23.7404 29.9803L31.3195 20.1032C31.8238 19.4459 31.6999 18.5043 31.0427 18C30.3854 17.4957 29.4438 17.6196 28.9395 18.2769Z"
        fill="#FFD140"
      />
    </g>
  </svg>
);
